module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-onvoltooid-passief.json
// module id = 1304
// module chunks = 270725734929029